import { render, staticRenderFns } from "./coalseach.vue?vue&type=template&id=5568a276&scoped=true"
import script from "./coalseach.vue?vue&type=script&lang=js"
export * from "./coalseach.vue?vue&type=script&lang=js"
import style0 from "./coalseach.vue?vue&type=style&index=0&id=5568a276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5568a276",
  null
  
)

export default component.exports